export const carouselOptions = {};
